module.exports = __webpack_public_path__ + "8fa04d49c3081cc3ec999c6eddcbd608.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/app-page/data-to-make-you-better/screens/desktop/ride.png
// module id = 1744
// module chunks = 1